import api from "../../config/client.axios.api";

export const createResultApi = async (infoCreate: any) => {
  const response = await api.post(`/results`, infoCreate);
  return response.data;
};
